export default class TramQT_QN {
    constructor(item) {
        this.gid = item.gid
        this.idtramquantrac = item.id
        this.sohieu = item.soHieu
        this.tentram = item.tenTram
        this.hangtram = item.hangTram
        this.diadiem = item.diaDiem
        this.toado = item.toaDo
        this.donviquanly = item.donViQuanLy
        this.namxaydung = item.namXayDung
        this.namsudung = item.namSuDung
        this.tpmt_ma = item.tpmT_Ma
        this.matinh = item.maTinh
        this.mahuyen = item.maHuyen
        this.maxa = item.maXa
        this.tendvhc = item.tenDVHC
        this.thuocsong = item.thuocSong
        this.thuoclvs = item.thuocLVS
        this.loaitram = item.loaiTram
        this.thongtinchung_id = item.thongTinChung_Id
    }
}